import { useTranslation } from 'react-i18next';
import { TranslationsKeys } from '../../../../../locales/translations';
export function useTexts() {
  const { t } = useTranslation(TranslationsKeys.STUDENT_RISK_HISTORY);
  return {
    subtitle: t('subtitle'),
    primaryFilters: {
      school: t('primaryFilters.school'),
      year: t('primaryFilters.year'),
      period: t('primaryFilters.period'),
    },
    secondaryFilter: {
      initialDate: t('secondaryFilter.initialDate'),
      endDate: t('secondaryFilter.endDate'),
      nameOrId: t('secondaryFilter.nameOrId'),
      session: t('secondaryFilter.session'),
      studyPlan: t('secondaryFilter.studyPlan'),
      campus: t('secondaryFilter.campus'),
      promotion: t('secondaryFilter.promotion'),
      course: t('secondaryFilter.course'),
    },
    buttons: {
      search: t('buttons.search'),
      clear: t('buttons.clear'),
      download: t('buttons.download'),
    },
    table: {
      title: t('table.title'),
      headers: {
        date: t('table.headers.date'),
        session: t('table.headers.session'),
        studentInfo: t('table.headers.studentInfo'),
        studyPlan: t('table.headers.studyPlan'),
        campus: t('table.headers.campus'),
        promotion: t('table.headers.promotion'),
        course: t('table.headers.course'),
        riskLevel: t('table.headers.riskLevel'),
        isActive: t('table.headers.isActive'),
        conditional: t('table.headers.conditional'),
        action: t('table.headers.action'),
      },
      content: {
        detailButton: t('table.content.detailButton'),
        badgeStatuses: {
          inactive: t('table.content.badgeStatuses.inactive'),
          active: t('table.content.badgeStatuses.active'),
        },
        conditionality: {
          yes: t('table.content.conditionality.yes'),
          no: t('table.content.conditionality.no'),
        },
        recategorizedTooltip: t('table.content.recategorizedTooltip'),
      },
      noRecords: t('table.noRecords'),
      noRecordsSubtitle: t('table.noRecordsSubtitle'),
    },
  };
}
